export const CARD_HEIGHT = 5;
export const CARD_WIDTH = 5;
